import { render, staticRenderFns } from "./store-groupbuy-card.vue?vue&type=template&id=0db9c2b2&scoped=true&"
import script from "./store-groupbuy-card.vue?vue&type=script&lang=js&"
export * from "./store-groupbuy-card.vue?vue&type=script&lang=js&"
import style0 from "./store-groupbuy-card.vue?vue&type=style&index=0&id=0db9c2b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9c2b2",
  null
  
)

export default component.exports